import { Availability } from '../types';
import { utcTimestampToLocal } from './timezone';

export function slotKeyFromAvailability(avail: Availability): string | null {
  if (!avail.available) return null;
  if (avail.utc_timestamp) {
    const { date, hour } = utcTimestampToLocal(avail.utc_timestamp);
    return `${date}-${hour}`;
  }
  if (avail.day && Number.isFinite(avail.hour)) {
    return `${avail.day}-${avail.hour}`;
  }
  return null;
}

export function buildSlotParticipantMap(availability: Availability[]): Map<string, string[]> {
  const sets = new Map<string, Set<string>>();
  for (const avail of availability) {
    const key = slotKeyFromAvailability(avail);
    if (!key) continue;
    let set = sets.get(key);
    if (!set) {
      set = new Set();
      sets.set(key, set);
    }
    set.add(avail.participant);
  }
  const out = new Map<string, string[]>();
  sets.forEach((participants, key) => {
    out.set(key, Array.from(participants).sort());
  });
  return out;
}

export function normalizeAvailabilityForViewer(availability: Availability[]): Availability[] {
  const byParticipantSlot = new Map<string, Availability>();
  for (const avail of availability) {
    if (!avail.available) continue;
    let normalized = avail;
    if (avail.utc_timestamp) {
      const { date, hour } = utcTimestampToLocal(avail.utc_timestamp);
      normalized = { ...avail, day: date, hour };
    }
    const dedupeKey = avail.utc_timestamp
      ? `${avail.participant}|${avail.utc_timestamp}`
      : `${avail.participant}|${avail.day}|${avail.hour}`;
    byParticipantSlot.set(dedupeKey, normalized);
  }
  return Array.from(byParticipantSlot.values());
}
